
    import {defineComponent, PropType} from 'vue';
    import FreelancerPrice from '@/project-proposal/common/ui/FreelancerPrice.vue';
    import {SelectedFreelancerResource} from '@/project-proposal/freelancer-selection/SelectedFreelancerResource';
    import {useGlobalProperties} from '@malt/vue3-use';

    export default defineComponent({
        name: 'SelectedFreelancerList',
        components: {
            FreelancerPrice,
        },
        props: {
            freelancers: {type: Array as PropType<SelectedFreelancerResource[]>, required: true},
        },
        setup() {
            const {$msg, $requireMsg, $icu} = useGlobalProperties();
            $requireMsg('project.response.time.*');

            function getAvgAnsweringTime(profile: SelectedFreelancerResource): string {
                return $msg(
                    'project.submission.body.introduction.response.text',
                    profile.firstName,
                    $msg('project.response.time.' + profile.avgAnsweringTime),
                );
            }

            function getRecommendationText(reco: number): string {
                return $icu('missions.stats.recommendations.count', {
                    nbRecos: reco,
                });
            }

            return {
                getAvgAnsweringTime,
                getRecommendationText,
            };
        },
    });
